<template>
    <div class="dropdown fpdates" :class="{ 'selected' : dateValues != null }">
        <button class="dropdown__button" @click="openFlatpickr">{{dateStr}}</button>
        <flat-pickr ref="flatpickr" v-model="dateValues" :config="config"></flat-pickr>
    </div>
</template>
<script>
    export default {
        props: {
            value: Object,
        },
        data() {
            return {
                config: {
                    mode: 'range',
                    static: true,
                },
                dateValues: null
            }
        },
        computed: {
            dateStr() {
                return this.dateValues == null ? 'Select Dates' : this.dateValues
            },
            parts() {
                return this.dateValues == null ? [] : this.dateValues.split(' ')
            },
            fromDate() {
                return this.parts.length > 0 ? this.parts[0] : ''
            },
            toDate() {
                return this.parts.length == 3 ? this.parts[2] : ''
            }
        },
        watch: {
            dateStr() {
                this.$emit('input', { from: this.fromDate, to: this.toDate })
            }
        },
        methods: {
            openFlatpickr() {
                this.$refs.flatpickr.fp.open()
            }
        },
        mounted() {
        }
    }
</script>